<template>
  <div class="filtering filtering--full">
    <OverlayContainer class="search__components" :event-bus="eventBus">
      <component
        v-for="(component, index) in ui.components"
        v-bind="component.props"
        :key="index"
        :is="component.type"
        :id="component.id"
        :event-bus="eventBus"
        :product-type-id="searchRequest[0]"
        :ads-count="adsCount"
        :search-request="searchRequest"
        :title="component.props.title"
        :product-type-name-singular="productTypeNameSingular"
        :product-type-name-plural="productTypeNamePlural"
        :search-types="component.searchTypes"
      ></component>
    </OverlayContainer>

    <ClearSearch
      class="clear-search--fixed-bottom"
      :event-bus="eventBus"
      :children="ui.components"
      :ads-count="adsCount"
      :search-request="searchRequest"
      :product-type-name-singular="productTypeNameSingular"
      :product-type-name-plural="productTypeNamePlural"
    ></ClearSearch>
  </div>
</template>

<script>
import ClearSearch from '@search/ClearSearch/ClearSearch.vue'
import TextSearch from '@search/TextSearch/TextSearch.vue'
import OverlayContainer from '@shared/Overlay/OverlayContainer.vue'

export default {
  data() {
    return {
      ui: {},
    }
  },
  components: {
    TextSearch,
    ClearSearch,
    OverlayContainer,
  },
  props: {
    searchRequest: { default: null, type: Array },
    eventBus: { default: null, type: Object },
    uiProp: { default: null, type: Object },
    adsCount: { default: 0, type: Number },
    productTypeNameSingular: { default: '', type: String },
    productTypeNamePlural: { default: '', type: String },
  },
  created() {
    this.ui = this.uiProp
    const advancedSearchIndex = this.ui.components.findIndex(
      component => component.type === 'AdvancedSearch'
    )

    if (advancedSearchIndex !== -1) {
      // get children
      const children = [
        ...this.ui.components[advancedSearchIndex].props.children,
      ]
      // remove from components
      this.ui.components.splice(advancedSearchIndex, 1)
      // add children to components
      this.ui.components.push(...children)
    }
  },
}
</script>

<style lang="scss">
@import 'Filtering.scss';
</style>
